module.exports = __webpack_public_path__ + "media/src/assets/Images/RealEstate-d28297bf0e938b715251b1af2ca841e4.svg";